import { defineComponent, computed } from "vue";
import { addSuffix } from "../../../utils/utils.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SvgIcon",
  props: {
    size: null,
    responseSize: null,
    customClass: null,
    icon: null,
    color: null
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    const customStyle = computed(
      () => props.size ? `width: ${addSuffix(props.size)};height: ${addSuffix(props.size)};` : ""
    );
    function handleClick(event) {
      emit("click", event);
    }
    return { __sfc: true, props, emit, customStyle, handleClick };
  }
});
export {
  _sfc_main as default
};
